import { apiHelpers } from '../utils/api';
import type { Vendor, VendorFormData, VendorStats, VendorFilters, VendorPagination } from '../types/vendor';

export interface GetVendorsResponse {
  data: Vendor[];
  pagination: VendorPagination;
}

export const vendorService = {
  // Get all vendors with filters and pagination
  async getVendors(filters: VendorFilters = {}): Promise<GetVendorsResponse> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.status) params.append('status', filters.status);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    return await apiHelpers.get(`/vendors?${params.toString()}`);
  },

  // Get single vendor by ID
  async getVendor(id: string): Promise<Vendor> {
    return await apiHelpers.get(`/vendors/${id}`);
  },

  // Create new vendor
  async createVendor(data: VendorFormData): Promise<Vendor> {
    console.log('🔥 VENDOR SERVICE: Creating vendor with data:', data);
    console.log('🔥 VENDOR SERVICE: Calling POST /vendors');

    try {
      const result = await apiHelpers.post<Vendor>('/vendors', data);
      console.log('✅ VENDOR SERVICE: Vendor created successfully:', result);
      return result as Vendor; // Fixed TypeScript error
    } catch (error) {
      console.error('❌ VENDOR SERVICE: Failed to create vendor:', error);
      throw error;
    }
  },

  // Update existing vendor
  async updateVendor(id: string, data: Partial<VendorFormData>): Promise<Vendor> {
    return await apiHelpers.put(`/vendors/${id}`, data);
  },

  // Delete vendor (soft delete)
  async deleteVendor(id: string): Promise<void> {
    return await apiHelpers.delete(`/vendors/${id}`);
  },

  // Get vendor statistics
  async getVendorStats(): Promise<VendorStats> {
    return await apiHelpers.get('/vendors/stats');
  }
};